module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: _vm.buffer.name,
    staticClass: "kiwi-messagelist",
    on: {
      "scroll": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.onThreadScroll($event)
      },
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.onListClick($event)
      }
    }
  }, [(_vm.shouldShowChathistoryTools) ? _c('div', {
    staticClass: "kiwi-messagelist-scrollback"
  }, [_c('a', {
    staticClass: "u-link",
    on: {
      "click": function($event) {
        _vm.buffer.requestScrollback()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('messages_load')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredMessages), function(message, idx) {
    return [(_vm.shouldShowDateChangeMarker(idx)) ? _c('div', {
      staticClass: "kiwi-messagelist-seperator"
    }, [_c('span', [_vm._v(_vm._s((new Date(message.time)).toDateString()))])]) : _vm._e(), _vm._v(" "), (_vm.shouldShowUnreadMarker(idx)) ? _c('div', {
      staticClass: "kiwi-messagelist-seperator"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('unread_messages')))])]) : _vm._e(), _vm._v(" "), (_vm.listType === 'modern') ? _c('message-list-message-modern', {
      key: message.id,
      attrs: {
        "message": message,
        "idx": idx,
        "ml": _vm.thisMl
      }
    }) : _vm._e(), _vm._v(" "), (_vm.listType !== 'modern') ? _c('message-list-message-compact', {
      key: message.id,
      attrs: {
        "message": message,
        "idx": idx,
        "ml": _vm.thisMl
      }
    }) : _vm._e()]
  }), _vm._v(" "), (_vm.buffer.getNetwork().state !== 'connected') ? _c('not-connected', {
    attrs: {
      "buffer": _vm.buffer,
      "network": _vm.buffer.getNetwork()
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9ffe906c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MessageList.vue
// module id = 503
// module chunks = 2